// components/SplashScreen.js
import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import cjsoilogo from '../assets/CJSOI-2K25-Blue-Logo-2.png'
import cjsoibg from '../assets/CJSOIBrandBG.png';

const LoadingScreen = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '320px',
        px: 5,
        mx: 'auto',
        color: 'white',
        backgroundPosition: 'center',
          backgroundImage: `url(${cjsoibg}),linear-gradient(159deg, rgba(0,71,171,1) 0%, rgba(28,169,201,1) 100%)`,
         borderRadius: '5%',
         boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
      }}
      
    >
        <img style={{marginTop: -20}}  src={cjsoilogo} alt='CJSOI Logo'/>
      <Typography variant="subtitle1" sx={{ mb: 4, textAlign: 'center' }}>
        Chargement des informations sur les jeux...
      </Typography>
      <CircularProgress sx={{ color: 'white', mb: 5 }} />
    </Box>
  );
};

export default LoadingScreen;
